<template>
  <div class="card mb-25 border-0 rounded-0 bg-white">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div
        class="mb-15 mb-md-25 d-sm-flex align-items-center justify-content-between"
      >
        <h5 class="card-title fw-bold mb-0">{{ nom }}</h5>
      </div>
      <div id="clientPaymentStatusChart" class="chart">
        <apexchart
          type="polarArea"
          height="430"
          :options="optionChart"
          :series="serieChart"
        ></apexchart>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "PolarAreaChart",
  props: {
    nom:{
			type:String,
			required: true,
		},
    serie:{
			type: Array,
			required: true,
		},
    labels:{
			type: Array,
			required: true,
		},
    colors:{
			type: Array,
			required: true,
		},
  },
  setup:(props) =>{
      const proj = ref(props.serie);
      const serieChart= proj.value;
      const optionChart= {
        chart: {
          height: 430,
          type: "polarArea",
        },
        stroke: {
          colors: ["#ffffff"],
        },
        labels: props.labels,
        colors: props.colors,
        plotOptions: {
          polarArea: {
            rings: {
              strokeColor: "#E9E8EE",
            },
          },
        },
        tooltip: {
          style: {
            fontSize: "14px",
            fontFamily: "Red Hat Display, sans-serif",
          },
        },
        fill: {
          opacity: 1,
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: true,
          fontWeight: 500,
          fontSize: "14px",
          position: "bottom",
          horizontalAlign: "left",
          fontFamily: "Red Hat Display, sans-serif",
          labels: {
            colors: "#8E8DA1",
          },
          markers: {
            offsetX: -4,
            height: 10,
            width: 10,
          },
          itemMargin: {
            horizontal: 10,
            vertical: 5,
          },
        },
      };
    return {
      serieChart,
      optionChart,
    };
  },
});
</script>